import { Address } from './address';

export class AddressDuringSickness {
    addressType: string
    addressUpdatedFlg: string
    address: Address
    constructor() {
        this.address = new Address()
        this.addressType = ''
        this.addressUpdatedFlg = ''
    }
}


// WEBPACK FOOTER //
// ./src/app/bean/address-during-sickness.ts